var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e59124",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.9,49.8c11,0,19.7-8.8,19.7-19.7c0-11-8.8-19.7-19.7-19.7c-11,0-19.7,8.8-19.7,19.7C108.2,41.1,117,49.8,127.9,49.8z M45.4,50.2h30.1v30.1H45.4V50.2z M197.3,50.2l-14.9,30.1h30.1L197.3,50.2z M46.6,107.1h35.5c2.8,0,6.2-1,8.2-4l13.6-19.3V115h48.6 V83.8l13.6,19.3c2,3,5.4,4,8.2,4h35.5c11.2,0,12-17.5-0.4-17.5h-30.9l-17.7-25.9c-5.2-7.4-11.2-10.6-19.5-10.6H115 c-8.4,0-14.4,3.4-19.5,10.6l-18,25.8H46.8C34.4,89.5,35,107.1,46.6,107.1z M20.6,119.8V145h21.6v100.3H213V145h22.4v-25.2H20.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.86e20d32f1d234aec7832fe5b9bd460d.svg";
export { ForwardRef as ReactComponent };